import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { times } from 'lodash/fp';
import moment from 'moment';
import classnames from 'classnames';
import { DayPickerStyles } from '../../../components/DayPickerStyle';

import { ReactComponent as CalendarIcon } from '../../../../svgs/calendar.svg';
import { ReactComponent as FilterIcon } from '../../../../svgs/filter.svg';
import { ReactComponent as Cross } from '../../../../svgs/cross.svg';
import styles from './monthPicker.module.css';
import LearnMorePopUp from 'components/LearnMorePopUp/LearnMorePopUp';
import { width } from 'styled-system';

const getNumDisplayMonths = (sourceMonth, destinationMonth) => {
  if (sourceMonth <= destinationMonth) {
    return destinationMonth - sourceMonth + 1;
  }
  return 13 - sourceMonth + destinationMonth;
};

class MonthPicker extends Component {
  static propTypes = {
    onMonthChange: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    isShown: PropTypes.bool.isRequired,
    selectedDate: PropTypes.instanceOf(moment).isRequired,
    maxDays: PropTypes.number.isRequired,
    services: PropTypes.arrayOf(PropTypes.object),
    serviceSelected: PropTypes.func,
    locations: PropTypes.arrayOf(PropTypes.object),
    locationSelected: PropTypes.func,
    selectedLocation: PropTypes.object,
    selectedService: PropTypes.object,
  };
  state = {
    ShowServiceModal: false,
    SelectedService: this.props.selectedService,
    SelectedLocation: this.props.selectedLocation,
  };

  HideServiceModal = () => {
    this.setState({
      ShowServiceModal: false,
    });
  };

  ShowServiceModal = () => {
    this.setState({
      ShowServiceModal: true,
    });
  };

  ServiceSelected = e => {
    if (e) {
      this.setState({
        SelectedService: e,
      });
      if (this.props.serviceSelected) {
        this.props.serviceSelected(e);
      }
    }
  };

  LocationSelected = e => {
    if (e) {
      this.setState({
        SelectedLocation: e,
      });
      if (this.props.locationSelected) {
        this.props.locationSelected(e);
      }
    }
  };

  clearSelect = () => {
    this.setState({
      SelectedService: null,
    });
    if (this.props.serviceSelected) {
      this.props.serviceSelected(null);
    }
  };

  render() {
    const thisMonth = moment().month();
    const maxMonth = moment()
      .add(this.props.maxDays, 'days')
      .month();
    return (
      <div className={styles.container}>
        {this.state.ShowServiceModal && (
          <LearnMorePopUp
            hide={this.HideServiceModal}
            type={'SERVICE_FILTER'}
            callback={this.ServiceSelected}
            locationCallback={this.LocationSelected}
            params={{
              Services: this.props.services,
              SelectedService: this.state.SelectedService,
              Locations: this.props.locations,
              SelectedLocation: this.state.SelectedLocation,
            }}
          />
        )}
        <div onClick={this.ShowServiceModal}>
          <FilterIcon className={styles.filterIcon} />
        </div>
        <DayPickerStyles />
        {(this.state.SelectedService?.Id ?? 0) === 0 && (
          <div
            onClick={this.ShowServiceModal}
            className={styles.servicePlaceholder}
          >
            Services
          </div>
        )}
        <div style={{ width: '60%' }}>
          {this.state.SelectedService && (
            <div className={styles.selectedDocBackground}>
              <div className={styles.selectedDoc}>
                {this.state.SelectedService.Name}
              </div>
              <Cross onClick={this.clearSelect} className={styles.cross} />
            </div>
          )}
        </div>
        <div className={styles.months}>
          {this.props.isShown ? (
            times(e => (
              <span
                className={classnames(styles.month, {
                  [styles.selected]:
                    this.props.currentMonth.month() ===
                    moment()
                      .add(e, 'months')
                      .month(),
                })}
                onClick={() => this.props.onMonthChange(e)}
                key={e}
              >
                {moment()
                  .add(e, 'months')
                  .format('MMMM')}
              </span>
            ))(getNumDisplayMonths(thisMonth, maxMonth))
          ) : (
            <span
              className={classnames(styles.month, styles.bright)}
              onClick={this.props.onClick}
              key={0}
            >
              {this.props.selectedDate.format('MMMM')}
            </span>
          )}
        </div>
        <div onClick={this.props.onClick}>
          <CalendarIcon className={styles.icon} />
        </div>
      </div>
    );
  }
}

export default MonthPicker;
